import React from "react";
import { getLanguages } from "./i18n";

export type DateRangeMode = "short" | "long";

/**
 * Returns a React fragment containing the two dates and the appropriate separator (either an inline SVG arrow or a dash).:
 * - "short": without year + inline SVG arrow
 * - "long" : with year + dash
 *
 * @param start   Start date
 * @param end     End date
 * @param mode    "short" or "long"
 */

export function formatDateRange(
  start: Date,
  end: Date,
  mode: DateRangeMode = "short",
  locales: string[] = getLanguages(),
): React.ReactNode {
  const opts: Intl.DateTimeFormatOptions = {
    month: "short",
    day: "numeric",
    ...(mode === "long" ? { year: "numeric" } : {}),
  };
  const fmt = new Intl.DateTimeFormat(locales, opts);
  const from = fmt.format(start);
  const to = fmt.format(end);

  return (
    <div style={{ display: "inline-flex", alignItems: "center" }}>
      <span>{from}</span>
      {mode === "short" ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          aria-hidden
          style={{ margin: "0 4px" }}
        >
          <path
            d="M11.7979 7.24664C11.9335 7.111 11.9335 6.88785 11.7979 6.75221L7.94745 2.90178C7.81181 2.76614 7.58866 2.76614 7.45302 2.90178C7.31738 3.03742 7.31738 3.26057 7.45302 3.39621L10.7062 6.64938H2.44965C2.25713 6.64938 2.09961 6.8069 2.09961 6.99942C2.09961 7.19195 2.25713 7.34946 2.44965 7.34946H10.7062L7.45302 10.6026C7.31738 10.7383 7.31738 10.9614 7.45302 11.0971C7.58866 11.2327 7.81181 11.2327 7.94745 11.0971L11.7979 7.24664Z"
            fill="#6F7074"
          />
        </svg>
      ) : (
        <span style={{ margin: "0 4px" }}>–</span>
      )}
      <span>{to}</span>
    </div>
  );
}
